var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canEmail)?_c('v-btn',{attrs:{"small":"","text":"","loading":_vm.loading},on:{"click":function($event){return _vm.email()}}},[_vm._v("Email")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }